import React from "react"
import { debounce } from "lodash"

const useDebouncedSetter = (setter) =>
  React.useMemo(
    () =>
      debounce((value) => {
        setter(value)
      }),
    [setter]
  )

export default useDebouncedSetter
